import React, { useEffect, useRef, useState } from 'react'
import './leaderboard.styles.scss';
import { getFilteredDataFromRtDb, getGameElementsFromDbForPlayers, getLeaderboardChangeDataFromDb, getLeaderboardDataFromDb, getLeaderboardDataFromRtDb, getLiveDataFromDb, getRegsFromDb, getUniqueDocumentFromDb } from '@/utils/getDataFromDb';
import { useParams } from 'react-router-dom'
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import LeaderboardItem from './leaderboard-item.component';
import { useSelector } from 'react-redux';
import { off } from 'firebase/database';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import Modal, { ModalAlert } from '@/components/modal/modal.component';
import LeaderboardSettings from './leaderboard-settings.component';
import { format } from 'date-fns';

const LeaderboardPage = ({ 
    playerView,
    playerData 
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const { livePath } = useParams();
    const [ liveData, setLiveData ] = useState(null);
    const [ leaderData, setLeaderData ] = useState(null);
    const [ levels, setLevels ] = useState(null);
    const [ gameData, setGameData ] = useState(null);
    const [ dataToDisplay, setDataToDisplay ] = useState({});
    const [ adminAccess, setAdminAccess ] = useState(false);
    const [ showSettingsModal, setShowSettingsModal ] = useState(false);
    const [ displayCount, setDisplayCount ] = useState(0);
    const [ alertMessage, setAlertMessage ] = useState(false);
    const levelRef = useRef();
    let liveListener;
    let gameListener;
    let leaderboardListener;
    let levelListener;
    let badgeListener;
    let changeListener;
    let regsListener;
 
    useEffect(() => {

        return () => {
            if (liveListener) liveListener();
            if (gameListener) gameListener();
            if (leaderboardListener) off(leaderboardListener);
            if (levelListener) levelListener();
            if (badgeListener) badgeListener();
            if (changeListener) off(changeListener);
            if (regsListener) regsListener();
        }
    }, [])

    useEffect(() => {
        if (!livePath) return;
        // console.log(livePath);
        
        getLiveData();
    }, [livePath])

    useEffect(() => {
        if (!leaderData || !liveData) return;
        checkAdminAccess();
        if (liveData.data === 'change') {
            getChangeData();
        } else {
            compileLeaderData();
        }
    }, [leaderData, liveData, userProfile])

    function checkAdminAccess() {
        if (!userProfile) return;
        getRegsFromDb({
            'gameId': liveData.gameId,
            'callback': callback,
            'handleListener': handleListener
        })
        function callback(data) {
            if (
                data.roles[userProfile.appId] &&
                (
                    data.roles[userProfile.appId].includes('owner') ||
                    data.roles[userProfile.appId].includes('manager')
                )
            ) {
                setAdminAccess(true);
            }
        }
        function handleListener(unsub) {
            regsListener = unsub;
        }
    }

    function getChangeData() {
        console.log('getting change data')
        getLeaderboardChangeDataFromDb({
            'gameId': liveData.gameId,
            'leaderboardId': liveData.id,
            'callback': callback,
            'handleListener': handleListener,
        })

        function callback(changeData) {
            compileLeaderData(changeData);
        }
        function handleListener(unsub) {
            changeListener = unsub;
        }
    }

    async function compileLeaderData(changeData) {
        let leaderObj = {};
        for (let l of Object.values(leaderData).filter(l => l.status === 'active')) {
            if (
                (
                    liveData.indOrTeams === 'teams' && 
                    !l.team
                ) || (
                    liveData.indOrTeams === 'individuals' && 
                    l.team
                )
            ) {
                continue;
            }
            let obj = {
                'playerId': l.playerId,
                'name': 
                    liveData.nameDisplay === 'full' 
                    ? `${l.fName} ${l.lName}` 
                    : liveData.nameDisplay === 'display' 
                    ? l.displayName 
                    : l.secretName,
                'icon': l.icon,
                'gradient': l.gradient,
                'badges': l.badges,
            }
            if (changeData) {
                if (changeData[l.playerId]) {
                    let playerChange = changeData[l.playerId];
                    let baseline = 0;
                    let newData = 0;
                    let change = 0;
                    let pct = 0;
                    if (playerChange.baseline) {
                        baseline = playerChange.baseline;
                    }
                    if (playerChange.newData) {
                        newData = playerChange.newData;
                    } else {
                        newData = baseline;
                    }
                    change = newData - baseline;
                    pct = 0;
                    if (baseline !== 0 && change !== 0) {
                        pct = (change / baseline) * 100
                    }
                    if (liveData.opt_changeDisplay === 'actual') {
                        obj.data = change;
                    } else {
                        obj.data = pct;
                        obj.actual = change;
                    }
                } else {
                    obj.data = 0;
                    obj.actual = 0;
                }
            } else {
                obj.data = l[liveData.data] ?? 0;
            }
            
            if (
                dataToDisplay[obj.playerId] && 
                dataToDisplay[obj.playerId].data !== obj.data
            ) {
                obj.animate = true;
            }
            leaderObj[obj.playerId] = obj
        }
        setDataToDisplay(leaderObj);
        console.log(leaderObj);
    }

    function getLiveData() {
        // console.log('getting live data')
        getLiveDataFromDb({
            'path': livePath, 
            'status': 'active', 
            'callback': callback, 
            'handleListener': handleListener
        })
        function callback(data) {
            setLiveData(data);
            // console.log(data);
            getLeaderboardData(data.gameId);
            getGameData(data.gameId, data.name);
            if (data.levels) {
                getLevels(data.gameId);
            }
            setDisplayCount(data.count);
            // if (data.badges) {
            //     getBadges(data.gameId);
            // }
        }
        function handleListener(unsub) {
            liveListener = unsub;
        }
    }

    function getGameData(gameId, leaderboardName) {
        getUniqueDocumentFromDb({
            'collection': 'games',
            'docId': gameId,
            'callback': callback,
            'handleListener': handleListener,
        })
        function callback(data) {
            setGameData(data);
            changeDocumentTitle(`Gamably | ${leaderboardName}`, data.icon);
        }
        function handleListener(unsub) {
            gameListener = unsub;
        }
    }
    
    function getLeaderboardData(gameId) {
        console.log('getting leaderboard data')
        getLeaderboardDataFromRtDb({'gameId': gameId,'callback': callback, 'handleListener': handleListener})
        function callback(data) {
            let leaderObj = {};
            for (let l of Object.values(data)) {
                if (l.status === 'active') {
                    leaderObj[l.playerId] = l;
                }
            }
            setLeaderData(leaderObj);
        }
        function handleListener(unsub) {
            leaderboardListener = unsub;
        }
    }

    function getLevels(gameId) {
        getFilteredDataFromRtDb({
            'path': `gameElementDocs/${gameId}`,
            'key': 'type',
            'value': 'level',
            'callback': callback,
            'handleListener': handleListener
        })
        // getGameElementsFromDbForPlayers({'gameId': gameId, 'type': 'level', 'status': 'active', 'callback': callback, 'handleListener': handleListener})
        function callback(data) {
            levelRef.current = {...levelRef.current, ...{[data.id]: data}}
            setLevels(levelRef.current);
        }
        function handleListener(unsub) {
            levelListener = unsub;
        }
    }

    function showFullLeaderboard() {
        console.log('full')
        setDisplayCount(Object.values(dataToDisplay).length);
        setAlertMessage('Full Leaderboard is now displayed.');
    }
    return (
        <div className='leaderboard-page-container'>
        {
            (gameData) 
            ?
            <div className={`leaderboard-page-content ${screenSize}`} style={
                (gameData.bg.type === 'gradient')
                ?
                {'background': `linear-gradient(to bottom, ${gameData.bg.hexTop}, ${gameData.bg.hexBottom})`}
                :
                {'background': `url("${gameData.bg.url}") no-repeat center center fixed`}
            }>
                {
                    (adminAccess) &&
                    <div className='menu-button'>
                        <button 
                            className={`g-button ${screenSize === 'mobile' ? 'med-btn' : ''}`}
                            onClick={() => setShowSettingsModal(true)}>
                            <FontAwesomeIcon 
                                icon={faGear}
                                size="xl" />
                        </button>
                    </div>
                }
                <div className='leaderboard-header content'>
                    <div className='leaderboard-head-image'>
                        <ImageContainer src={gameData.header} alt='game primary icon' />
                    </div>
                    {
                        (liveData) &&
                        <div className='leaderboard-head-title'>
                            {liveData.name}
                        </div>
                    }
                </div>
                {/* <div className="g-space-0-5"></div> */}
                {
                    (liveData && liveData.data === 'change') &&
                    <div>
                        {
                            (liveData.opt_baselineSetDate)
                            ? <div className='meta'>Baseline set {format(new Date(liveData.opt_baselineSetDate), "Pp")}</div>
                            : <div className='meta'>No baseline has been set to measure change.</div>
                        }
                        {
                            (liveData.opt_dateEnd)
                            ? <div className='meta'>Will stop tracking on {format(new Date(liveData.opt_dateEnd), "Pp")}</div>
                            : null
                        }
                    </div>
                }
                <div className='g-space-0-5'></div>
                {
                    (Object.values(dataToDisplay).length > 0 && liveData)
                    ?
                    <div className='leaderboard-content content'>
                        {
                            Object.values(dataToDisplay)
                            .sort((a,b) => a.data < b.data ? 1 : -1)
                            .map((l, index) => {
                                if (l.data < 0) console.log(l);
                                if (index + 1 > displayCount) return;
                                return (
                                <div  key={l.playerId}>
                                    <LeaderboardItem 
                                        leader={l} 
                                        index={index} 
                                        liveData={liveData} 
                                        levels={levels} 
                                        playerView={playerView} />
                                </div>
                                )
                            })
                        }
                        {
                            (
                                playerView && 
                                playerData &&
                                dataToDisplay[playerData.playerId] &&
                                Object.keys(dataToDisplay).length > displayCount &&
                                Object.values(dataToDisplay).sort((a,b) => a.data < b.data ? 1 : -1).findIndex(l => l.playerId === playerData.playerId) >= displayCount
                            ) &&
                            <>
                                <h2>...</h2>
                                <LeaderboardItem
                                    leader={dataToDisplay[playerData.playerId]}
                                    index={Object.values(dataToDisplay).sort((a,b) => a.data < b.data ? 1 : -1).findIndex(l => l.playerId === playerData.playerId)}
                                    liveData={liveData}
                                    levels={levels}
                                    playerView={playerView} />
                            </>
                        }
                        <div></div>
                    </div>
                    :
                    <div className='center'><h1>Loading...</h1></div>
                }
            </div>
            :
            <div className='center'><h1>Loading Game Data...</h1></div>
        }
        <Modal
            show={showSettingsModal}
            cancel={() => setShowSettingsModal(false)}
            closeButton={true}
            text='Leaderboard Settings' >
            {
                (liveData) &&
                <div>
                <LeaderboardSettings 
                    liveData={liveData}
                    showFullLeaderboard={showFullLeaderboard} />
                    <hr/>
                    <div className='buttons'>
                        <button 
                            className='g-button'
                            onClick={() => setShowSettingsModal(false)}>
                            Done
                        </button>
                    </div>
                </div>
            }
        </Modal>
        <ModalAlert
            show={alertMessage}
            cancel={() => setAlertMessage(null)}
            message={alertMessage} />
        </div>
    )
}

export default LeaderboardPage